import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ProductDetailComponent} from '../products/components/product-detail/product-detail.component';
import {NavigationComponent} from '../shared/components';
import {CollectionDetailComponent} from './components/collection-detail/collection-detail.component';
import {CollectionsComponent} from './components/collections/collections.component';
import {LoggedInGuard} from '../../core/guards/logged-in.guard';


const routes: Routes = [{
  path: '',
  children: [
    {path: '', canActivate: [LoggedInGuard], component: CollectionsComponent},
    {path: 'collection-detail/:id', canActivate: [LoggedInGuard], component: CollectionDetailComponent},
    {path: 'collection-detail/:id/product/:productId', canActivate: [LoggedInGuard], component: ProductDetailComponent}
  ]
},
  {path: '', component: NavigationComponent, outlet: 'navigation'}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CollectionsRoutingModule {
}
